import { GROUP_HEX, INSTRUMENT_GROUPS } from './groupColors';

const numberOrZero = (value) => Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : 0;

export const normalizePack = (raw = {}) => {
  const groupCounts = INSTRUMENT_GROUPS.reduce((counts, group) => {
    counts[group] = numberOrZero(raw.group_counts?.[group]);
    return counts;
  }, {});
  const countTotal = Object.values(groupCounts).reduce((sum, count) => sum + count, 0);
  return {
    id: raw.pack_id ?? raw.id ?? null,
    name: raw.name ?? raw.title ?? '',
    description: raw.description ?? '',
    cover: raw.cover_image_url ?? null,
    tempo: raw.tempo !== null && raw.tempo !== undefined && raw.tempo !== '' && Number.isFinite(Number(raw.tempo)) ? Number(raw.tempo) : null,
    key: raw.key ?? null,
    moods: Array.isArray(raw.moods) ? raw.moods : [],
    styles: Array.isArray(raw.styles) ? raw.styles : [],
    groupCounts,
    total: countTotal || numberOrZero(raw.loop_count ?? raw.total_loops),
  };
};

export const packFeelLine = (pack) => [...(pack?.moods || []), ...(pack?.styles || [])].filter(Boolean).slice(0, 2).join(', ');

export const groupBarWidths = (counts = {}) => {
  const total = INSTRUMENT_GROUPS.reduce((sum, group) => sum + numberOrZero(counts[group]), 0);
  return INSTRUMENT_GROUPS.map((group) => ({ group, color: GROUP_HEX[group], width: total ? (numberOrZero(counts[group]) / total) * 100 : 0 }));
};

export const groupLabel = (group, count) => {
  const labels = {
    Melodies: ['melody', 'melodies'], Drums: ['drum loop', 'drums'],
    Textures: ['texture', 'textures'], 'Sound FX': ['sound effect', 'sound effects'],
  };
  return (labels[group] || ['sound', 'sounds'])[Number(count) === 1 ? 0 : 1];
};
